import React, { useEffect, useState, useRef } from 'react'
import '../styles.scss'
import _ from 'lodash';
import { deleteCartItem } from '../../../redux/cart/CartServices';
import { useSelector, useDispatch } from "react-redux";
import { clearCart, getCartItems, getDeliveryAddress, getRelatives } from '../../../redux/cart/CartAction'
import { selectedAddress } from '../../../redux/deliveryAddress/addressAction';
import { Button } from 'react-bootstrap';
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import DeliveryAddresses from './address-component-new/DeliveryAddresses';
import SelectRecipient from './SelectRecipient';

export default function PackageIndividualItem(props) {
    let { addressCallBack, itemDetails, recipients, cartUUID, packageDetails, indexx, errotText, errotToast, updateItems, mobileView, isRecommendedTest, checkedAddressList } = props;
    const dispatch = useDispatch();
    const focusPoint = useRef(null);
    const cartState = useSelector((state) => state.cartsData);
    const user = useSelector((state) => state.auth);
    const [qtyValue, setQtyValue] = useState([]);
    const [homeService, setHomeService] = useState([]);
    const [homeServicePrice, setHomeServicePrice] = useState();
    const [testQuantity, setTestQuantity] = useState(1);
    const [testPrice, setTestPrice] = useState();
    const [homeSampleQuantity, setHomeSampleQuantity] = useState(1);
    const [selectedRecipient, setSelectedRecipient] = useState([]);
    const [selectedRecipientName, setSelectedRecipientName] = useState([]);
    const [deleteRecipientIndex, setDeleteRecipiantindex] = useState([]);
    const [removeTestLabel, setRemoveTestLabel] = useState('Remove Test');
    const [selectOptions, setSelectOptions] = useState([]);
    const [selectAddressRedux, setSelectAddressRedux] = useState([]);
    const [dropdownPlaceHolder, setDropdownPlaceHolder] = useState('Select Recipient');
    const [selectedAddressList, setSelectedAddressList] = useState([]);
    const [selectedRecipientId, setSelectedRecipientId] = useState([]);
    const [selectedRecipientNames, setSelectedRecipientNames] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0)
        setDeleteRecipiantindex([])
        let data = [];
        let nameData = [];
        let patientIds = [];
        itemDetails && itemDetails.patient_name && Array.isArray(itemDetails.patient_name) && itemDetails.patient_name.forEach((item, index) => {
            setDropdownPlaceHolder('')
            let updatedItemValues = itemDetails
            updatedItemValues['quantity'] = itemDetails.quantity ? itemDetails.quantity : 1
            updatedItemValues.patient_uuid = itemDetails.patient_uuid
            if (itemDetails.isRecommendedTest === true) {
                updatedItemValues['rec_test'] = {
                    test_uuid: itemDetails.tests.testname_uuid,
                    patient_uuid: itemDetails.patient_uuid[0],
                    advice_id: localStorage.getItem('ADVICE_ID')
                }
            } else {
                updatedItemValues['rec_test'] = {}
            }

            updateItems(updatedItemValues, itemDetails.uuid, itemDetails.quantity)
            if (item !== '' && itemDetails.uuid.toString().startsWith('LPTD')) {
                data.push({ name: item, id: itemDetails.patient_uuid[index], cartItem: itemDetails, itemQuantity: testQuantity })
                nameData.push(item)
                patientIds.push(itemDetails.patient_uuid[index])
            } else {
                try {
                    focusPoint.current.resetSelectedValues()
                } catch (error) {
                    let placeHolder = `Select Recipient111`
                    setDropdownPlaceHolder(placeHolder)
                }
            }

        })
        setSelectedRecipientNames(nameData)
        setSelectedRecipientId(patientIds)
        if (data.length > 0) {
            setDropdownPlaceHolder('')
            setSelectedRecipientName(data)
        } else {
            setSelectedRecipientName([])
        }

        setQtyValue([])
        setTestQuantity(itemDetails.quantity ? itemDetails.quantity : 1)

    }, [cartState])


    useEffect(() => {
        dispatch(selectedAddress(selectAddressRedux))
    }, [selectAddressRedux])

    useEffect(() => {
        addressCallBack(selectedAddressList)
    }, [selectedAddressList])

    useEffect(() => {
        let data = []

        recipients && recipients.map((item) => {
            data.push({ name: item.full_name, id: item.uuid, cartItem: itemDetails, itemQuantity: testQuantity })
        })
        setSelectOptions(data)
    }, [recipients])


    useEffect(() => {
        // setTestPrice(itemDetails.doctallsexclusivediscountedprice)
        let qty = [];
        cartState.data.homeservice.map((i) => qty.push({ value: 1 }));
        setQtyValue(qty)
        // setHomeServicePrice(itemDetails.doctallsexclusivediscountedprice)
    }, [])


    useEffect(() => {
        let price = Number(itemDetails.doctallsexclusivediscountedprice) * testQuantity
        setTestPrice(price)
        if (testQuantity === selectedRecipientNames.length) {
            setDropdownPlaceHolder('')
        } else {
            let _placeHolder = `Select Recipient`
            setDropdownPlaceHolder(_placeHolder)
        }

    }, [selectedRecipientNames, testQuantity])

    useEffect(() => {
        if (itemDetails.name === "Home Service Charge") {
            setTestQuantity(1)
            let updatedItemValues = itemDetails
            let quantity = 1
            updatedItemValues['quantity'] = quantity
            updateItems(updatedItemValues, itemDetails.uuid, quantity)
        }
    }, [])

    const handleItemDelete = async () => {
        setRemoveTestLabel("Processing..")
        try {
            let response = await deleteCartItem(user.uuid, cartUUID, itemDetails.tests.uuid, itemDetails.tests.doctallsexclusivediscountedprice, itemDetails.patient_uuid)
            dispatch(clearCart())
            dispatch(getRelatives())
            dispatch(getCartItems())

            setRemoveTestLabel("Remove Test")
        } catch (error) {
            setRemoveTestLabel("Remove Test")
        }
    }



    const handleIncreseQuantity = () => {
        if (recipients.length == testQuantity) {
            errotToast(true)
            errotText("" + `You have ${recipients.length} recipient available to add, quantity can not be more than available recipient`)
        } else {
            let quantity = Number(testQuantity + 1)
            setTestQuantity(quantity)
            let updatedItemValues = itemDetails
            updatedItemValues.patient_uuid = selectedRecipientId
            updatedItemValues['quantity'] = quantity
            updateItems(updatedItemValues, itemDetails.uuid, quantity)
        }
    }

    const handleDecreseQuantity = () => {
        if (testQuantity == selectedRecipientNames.length) {
            errotToast(true)
            errotText("Please remove one of the selected recipient and try again")
        } else {
            if (testQuantity === 1) {
                errotToast(true)
                errotText("Minimum Test Quantity is 1")
            } else {
                if (testQuantity > 1) {
                    let quantity = Number(testQuantity - 1)
                    setTestQuantity(quantity)
                    let updatedItemValues = itemDetails
                    updatedItemValues.patient_uuid = selectedRecipientId
                    updatedItemValues['quantity'] = quantity
                    updateItems(updatedItemValues, itemDetails.uuid, quantity)
                }
            }
        }
    }

    //Home Sample increse-decrese

    const handleHomeSampleIncrese = () => {
        if (recipients.length == testQuantity) {
            errotToast(true)
            errotText("" + `You have ${recipients.length} recipient available to add, quantity can not be more than available recipient`)
        } else {
            let quantity = Number(testQuantity + 1)
            setTestQuantity(quantity)
            let updatedItemValues = itemDetails
            updatedItemValues['quantity'] = quantity
            updateItems(updatedItemValues, itemDetails.uuid, quantity)

        }
    }

    const handleHomeSampleDecrese = () => {
        if (testQuantity === 1) {
            errotToast(true)
            errotText("Minimum Home Sample Quantity is 1")
        } else {
            if (testQuantity > 1) {
                let quantity = Number(testQuantity - 1)
                setTestQuantity(quantity)
                let updatedItemValues = itemDetails
                updatedItemValues['quantity'] = quantity
                updateItems(updatedItemValues, itemDetails.uuid, quantity)
            }
        }
    }

    return (

        <>
            {/*From Here  */}
            <div className="inner-content-row-wrap">

                <div className='col-md-4 inner-content-align_name' >
                    <div className="left-cont-out" >
                        <div className="top-font">
                            {packageDetails.panel_name}
                        </div>
                    </div>
                    <div>
                        <span style={{ color: 'orange' }}>FREE</span> medical Report
                    </div>
                    <div>
                        <span style={{ color: 'orange' }}>FREE MEDICAL OFFICER</span> follow-up consultation (worth ₦8,600)
                    </div>
                    <div style={{ marginTop: '20px' }}>
                        <span>Results Expected in : 2 Days</span>
                    </div>
                    {/* <div style={{ marginTop: '6%' }}>{itemDetails.name === "Home Service Charge" &&
                        <DeliveryAddresses
                            homeServiceQuantity={testQuantity}
                            selectedAddressListCallBack={(list) => setSelectedAddressList(list)}
                            partnerName={itemDetails.lab_partner_name}
                        />}</div> */}

                </div>
                {
                    !mobileView ?
                        (
                            <>
                                <div className='col-md-2 inner-content-align_qty'>
                                    {itemDetails.isRecommendedTest && <div>1</div>}
                                    {itemDetails.name !== "Home Service Charge" ? <ButtonGroup>
                                        <Button variant='light' onClick={handleDecreseQuantity} className='quantity_btn' disabled={testQuantity === 1 ? true : false}>-</Button>
                                        <span style={{ backgroundColor: 'white', borderColor: 'white', color: 'black', marginRight: "15px", marginLeft: "15px", display: "flex", alignItems: "center" }}>{testQuantity}</span>
                                        <Button variant='light' onClick={handleIncreseQuantity} className='quantity_btn'>+</Button>
                                    </ButtonGroup> : <ButtonGroup>
                                        <Button variant='light' onClick={handleHomeSampleDecrese} className='quantity_btn' disabled={testQuantity === 1 ? true : false}>-</Button>
                                        <span style={{ backgroundColor: 'white', borderColor: 'white', color: 'black', marginRight: "15px", marginLeft: "15px", display: "flex", alignItems: "center" }}>{testQuantity}</span>
                                        <Button variant='light' onClick={handleHomeSampleIncrese} className='quantity_btn'>+</Button>
                                    </ButtonGroup>}
                                </div>

                                {/* Second End */}
                                <div className='col-md-2 inner-content-align_price' >
                                    <div className="center-cont-out ">
                                        <div>
                                            <div className="top-font">
                                                ₦ {Number(itemDetails.amount).toFixed()}
                                            </div>
                                            {/* <div className="bottom-font">
                                    ₦{itemDetails.amount}
                                </div> */}
                                        </div>
                                    </div>
                                </div></>
                        ) :
                        <></>
                }

                {
                    mobileView ?
                        <>
                            <span style={{ color: "black", display: "flex", justifyContent: "center", alignItems: "center", width: "110px" }}>
                                Quantity
                            </span>
                            <div style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between"
                            }}>
                                <div className='col-md-2 inner-content-align_price' >
                                    <div className="center-cont-out ">
                                        <div>
                                            <div className="top-font">
                                                ₦ {testPrice}
                                            </div>
                                            <div className="bottom-font">
                                                ₦ {itemDetails.amount}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </> : null
                }

                {/* Third End */}

                <div className='col-md-4 inner-content-align_recip' >
                    <div className="center-cont-out">
                        {
                            <div className="recipient">
                                <SelectRecipient
                                    ref={focusPoint}
                                    options={selectOptions && selectOptions}
                                    selectedValues={selectedRecipientName && selectedRecipientName}
                                    _callBack={(data) => updateItems(data, itemDetails.uuid)}
                                    _patientIdCallBack={(data) => setSelectedRecipientId(data)}
                                    _patientNameCallBack={(data) => setSelectedRecipientNames(data)}
                                    displayValue="name"
                                    selectionLimit={testQuantity}
                                    itemInfo={itemDetails}
                                    placeHolder={dropdownPlaceHolder}
                                />
                            </div>
                        }
                        {
                            itemDetails.isRecommendedTest &&
                            <div>
                                {itemDetails.patient_name}
                            </div>
                        }
                    </div>
                </div>

            </div>
            {<div className="bottom-row" onClick={handleItemDelete}>
                <div
                    className="cont"
                    style={{ cursor: "pointer", color: 'orange' }}
                    onClick={handleItemDelete}
                >
                    Remove Package
                </div>
            </div>}
            <div style={{ padding: "0 39px", marginTop: '20px' }}>{(itemDetails.name === "Home Service Charge" || itemDetails.items[0].home_service_included === "yes") &&
                <DeliveryAddresses
                    homeServiceQuantity={testQuantity}
                    selectedAddressListCallBack={(list) => setSelectedAddressList(list)}
                    partnerName={itemDetails.items[0].lab_partner_name}
                />}</div>
            <hr style={{ color: "#E3EAF6", height: '2px' }}></hr>
        </>
    )
}